import React from 'react';
import './Stats.css';

function Stats({ totalCount }) {
  return (
    <div className="stats">
      <span className="stats-text">
        Total number of collected data: <strong>{totalCount.toLocaleString()}</strong>
      </span>
    </div>
  );
}

export default Stats;

